<header class="flex header p-2">
  <h2>{{ 'DyehouseDailyMetric.preview_title' | translateWF: 'Import Preview' }}</h2>
</header>

<section class="content p-4">
  <!-- Summary stats -->
  <div class="flex mb-4">
    <div class="stat-chip stat-ok">
      <i class="pi pi-check-circle"></i>
      <span>{{ previewResult.totalOk }} {{ 'DyehouseDailyMetric.preview_total_ok' | translateWF: 'OK' }}</span>
    </div>
    <div class="stat-chip stat-duplicate">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ previewResult.totalDuplicates }} {{ 'DyehouseDailyMetric.preview_total_duplicates' | translateWF: 'Duplicates' }}</span>
    </div>
    <div class="stat-chip stat-missing">
      <i class="pi pi-times-circle"></i>
      <span>{{ previewResult.totalMissingData }} {{ 'DyehouseDailyMetric.preview_total_missing' | translateWF: 'Missing Data' }}</span>
    </div>
  </div>

  <!-- Duplicate warning + override toggle -->
  @if (hasDuplicates()) {
    <div class="duplicate-warning mb-4">
      <p-message severity="warn" styleClass="w-full mb-3">
        {{ 'DyehouseDailyMetric.preview_duplicate_warning' | translateWF: 'There are duplicate records. Enable override to replace them.' }}
      </p-message>
      <div class="flex align-items-center gap-2">
        <p-toggleswitch [ngModel]="overrideEnabled()" (ngModelChange)="overrideEnabled.set($event)" />
        <label>{{ 'DyehouseDailyMetric.preview_override_label' | translateWF: 'Override duplicates' }}</label>
      </div>
    </div>
  }

  <!-- Missing data blocker -->
  @if (hasMissing()) {
    <div class="missing-blocker mb-4">
      <p-message severity="error" styleClass="w-full">
        {{ 'DyehouseDailyMetric.preview_missing_blocker' | translateWF: 'There are rows with missing data. Import is blocked until they are fixed in the source file.' }}
      </p-message>
    </div>
  }

  <!-- Preview table -->
  <p-table [value]="previewResult.items" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'DyehouseDailyMetric.col_status' | translateWF: 'Status' }}</th>
        <th>{{ 'DyehouseDailyMetric.col_date' | translateWF: 'Date' }}</th>
        <th>{{ 'DyehouseDailyMetric.col_week' | translateWF: 'Week' }}</th>
        <th>{{ 'DyehouseDailyMetric.col_park_energy' | translateWF: 'Park Energy (T)' }}</th>
        <th>{{ 'DyehouseDailyMetric.col_bunker_dyeing' | translateWF: 'Bunker Dyeing (gal)' }}</th>
        <th>{{ 'DyehouseDailyMetric.col_bunker_finishing' | translateWF: 'Bunker Finishing (gal)' }}</th>
        <th>{{ 'DyehouseDailyMetric.col_water_agua' | translateWF: 'Water Agua (m³)' }}</th>
        <th>{{ 'DyehouseDailyMetric.col_water_inoptsa' | translateWF: 'Water Inoptsa (m³)' }}</th>
        <th>{{ 'DyehouseDailyMetric.col_energy' | translateWF: 'Energy (kWh)' }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr
        [ngClass]="{
          'row-ok': item.status === 'ok',
          'row-duplicate': item.status === 'duplicate',
          'row-missing': item.status === 'missing_data',
        }"
      >
        <td>
          <p-tag [value]="getStatusLabel(item.status)" [severity]="getStatusSeverity(item.status)" />
        </td>
        <td>{{ item.metric.date }}</td>
        <td>{{ item.metric.week }}</td>
        <td>{{ item.metric.parkEnergyTons }}</td>
        <td>{{ item.metric.bunkerGalDyeing }}</td>
        <td>{{ item.metric.bunkerGalFinishing }}</td>
        <td>{{ item.metric.waterAguaM3 }}</td>
        <td>{{ item.metric.waterInoptsaM3 }}</td>
        <td>{{ item.metric.energyKwh }}</td>
      </tr>
    </ng-template>
  </p-table>
</section>

<footer>
  <p-button [label]="'DyehouseDailyMetric.preview_cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onCancel()" />
  <p-button [label]="'DyehouseDailyMetric.preview_save' | translateWF: 'Confirm import'" severity="success" icon="pi pi-check" [disabled]="!canSave()" (click)="onConfirm()" />
</footer>
